import { useEffect,  useState } from 'react';
import './LoginCSS.css'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import { LoadingButton } from '@mui/lab';
import 'react-toastify/dist/ReactToastify.css';
import { Cookies } from 'react-cookie';
import Loader from './Loader';
import config, { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox } from '../Common/Input';
import { setFocus } from '../Common/Common';

const cookies = new Cookies();

export default function SignIn() {
    const StaticToken = config.secret_key;
    const source = 'web'
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState({ userCode: '', password: '' });
    let [state, setState] = useState(false);

    const handleLogin = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const data = {
            Token: StaticToken,
            UserCode: user.userCode !== '' ? user.userCode : '0',
            Password: user.password,
            Source: source
        }
        post(`${API_SERVER}/api/UserLogin/Login`, { ...data }, (res) =>
        {
            if (res.status === 'SUCCESS') {
                cookies.set('token', res.token);
                cookies.set('loginUserCode', res.loginUserCode);
                cookies.set('IsBackOfficeUser', res.isBackOfficeUser);
                cookies.set('userName', res.userName);
                cookies.set('salesPersonCode', res.salesPersonCode);
                cookies.set('warehouseCode', res.warehouseCode);
                cookies.set('warehouseName', res.warehouseName);
                setTimeout(() => {
                    setIsLoading(false);
                    navigate(location.state || '/dashboard')
                    localStorage.setItem('ID', "0")
                }, 700)
            } else {
                setState(false);
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus);
            }
        })
        
    };

    useEffect(() => {
        setFocus("txtUserCode");
        const cookies = new Cookies();
        cookies.remove('token')
        cookies.remove('loginUserCode')
        cookies.remove('userName')
        cookies.remove('CookieConsentByFineshop')
        cookies.remove('csrftoken')
        cookies.remove('salesPersonCode')
        cookies.remove('warehouseCode')
        cookies.remove('warehouseName')
    },[])

    return (
        <>
            <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
                <div className="row" data-aos="zoom-in" data-aos-duration="1000" >
                    <div className="col-sm-3 px-4 py-5 main-login text-black rounded">
                        <div >
                            <img src="./assets/img/Login.png" className='img1' alt="..." style={{ display: "flex" }} />
                        </div>
                        <div className="">
                            <form method='POST' >
                                <h5 className=" fs-4 my-2 text-center" style={{ textShadow: '2px 2px 2px var(--mycolorFilterCheckText)' }}> Welcome To
                                    <span className='fw-bold ' style={{ color: "var(--mycolorFilterCheckText)", textShadow: '1px 1px 1px white' }} > Lesken</span>
                                </h5>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label" style={{ color:'#fff' }}>User Code / Email ID / Mobile No</label>
                                        <input
                                            id="txtUserCode"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            name='userCode'
                                            placeholder='User Code / Email ID / Mobile No'
                                            maxLength='50'
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { setFocus("txtPassword") };
                                            }}
                                            value={user.userCode}
                                            onChange={(e) => {
                                                setUser({ ...user, userCode: e.target.value })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label" style={{ color: '#fff' }}>Password</label>
                                        <input
                                            id="txtPassword"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleLogin(e)
                                                };
                                            }}
                                            type="password"
                                            className="form-control"
                                            autoComplete="off"
                                            placeholder='Password'
                                            maxLength='20'
                                            name='Password'
                                            value={user.password}
                                            onChange={(e) => setUser({ ...user, password: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="py-2 loading">
                                    <LoadingButton loading={state} disabled={isLoading} style={{ background: "var(--mycolorFilterCheckText)" }} loadingPosition='center' onClick={handleLogin} className=' py-1' variant="contained"> Login </LoadingButton>
                                    {isLoading && (<Loader text='AUTHENTICATING' size='100px' img_path='./assets/img/giphy.gif' />)}
                                </div>

                                <Link className="text-light" style={{ fontSize: "14px" }}>
                                    forgot password?
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );
}





